import React, { Component, useState, useEffect, } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet, useNavigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import axios from 'axios';
import { AuthProvider, useAuth } from './AuthContext';
import { Layout } from './components/Layout';
import Login from './components/Login';
//import { setDefaultAuthToken } from './Api';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './reducer/store';
import { loginSuccess } from './actions/authActions';
import RequireAuth from './RequireAuth';
import { CookiesProvider, useCookies } from "react-cookie";
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import ForgotPassword from './components/ForgotPassword';
import PresistLogin from './components/PresistLogin';
import Poolings from './components/Poolings';
import PoolingDetails from './components/PoolingDetail';

const PrivateOutlet = ({ children, layout: LayoutComponent }) => {

    return (

        <LayoutComponent>
            {children}
            <Outlet />
        </LayoutComponent>
    );
};

const App = () => {
    let _routes = AppRoutes()
  

    return (
        //<Provider store={store}>

        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="terms-of-use" element={<TermsOfUse />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="poolings" element={<Poolings />} />
            <Route path="poolingDetails/:id" element={<PoolingDetails />} />

            <Route element={<PresistLogin />}>
                <Route element={<RequireAuth allowedRoles={["Admin"]} />} >
                    {_routes.adminRoutes.map((route, index) => {
                        const { element, layout, ...rest } = route;
                        return <Route key={index}  {...rest} element={<PrivateOutlet layout={layout} >{element}</PrivateOutlet>}></Route>
                    })}
                </Route>

                <Route element={<RequireAuth allowedRoles={["Primary Auctioneer", "Secondary Auctioneer", "Support Auctioneer"]} />} >
                    {_routes.auctioneerRoutes.map((route, index) => {
                        const { element, layout, ...rest } = route;
                        return <Route key={index}  {...rest} element={<PrivateOutlet layout={layout} >{element}</PrivateOutlet>}></Route>
                    })}
                </Route>

                <Route element={<RequireAuth allowedRoles={["Trader"]} />} >
                    {_routes.traderRoutes.map((route, index) => {
                        const { element, layout, ...rest } = route;
                        return <Route key={index}  {...rest} element={<PrivateOutlet layout={layout} >{element}</PrivateOutlet>}></Route>
                    })}
                </Route>

                <Route element={<RequireAuth allowedRoles={["Streamer"]} />} >
                    {_routes.streamerRoutes.map((route, index) => {
                        const { element, layout, ...rest } = route;
                        return <Route key={index}  {...rest} element={<PrivateOutlet layout={layout} >{element}</PrivateOutlet>}></Route>
                    })}
                </Route>

                <Route element={<RequireAuth allowedRoles={["Pooler"]} />} >
                    {_routes.poolerRoutes.map((route, index) => {
                        const { element, layout, ...rest } = route;
                        return <Route key={index}  {...rest} element={<PrivateOutlet layout={layout} >{element}</PrivateOutlet>}></Route>
                    })}
                </Route>
            </Route>
        </Routes>

    )
};

export default App;